import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { constants, lodash as _ } from '../../../common';
import './assignment.scss';

const { whoAssignmentTypes, whoUnionType } = constants;

export const getAssignmentSelection = (issue) => {
   const who = (issue && issue.who) || {};
   if (who.noWhoAssignmentType === whoAssignmentTypes.UNASSIGNED.id) return null;
   if (who.staff && who.staff.length) return { type: 'staff', no: who.staff[0].no };
   if (who.teams && who.teams.length) return { type: 'team', no: who.teams[0].no };
   return null;
};

export const buildAssignmentWho = (selection) => {
   if (!selection || selection.type === 'unassigned') {
      return {
         noWhoAssignmentType: whoAssignmentTypes.UNASSIGNED.id,
         noWhoUnionType: whoUnionType.ANY.id,
         teams: [],
         positions: [],
         staff: []
      };
   }

   if (selection.type === 'staff') {
      return {
         noWhoAssignmentType: whoAssignmentTypes.SPECIFIC_STAFF.id,
         noWhoUnionType: whoUnionType.ANY.id,
         teams: [],
         positions: [],
         staff: [{ no: selection.no }]
      };
   }

   return {
      noWhoAssignmentType: whoAssignmentTypes.SPECIFIC_TEAMS.id,
      noWhoUnionType: whoUnionType.ANY.id,
      teams: [{ no: selection.no }],
      positions: [],
      staff: []
   };
};

const sameSelection = (left, right) => {
   if (!left && !right) return true;
   return Boolean(left && right && left.type === right.type && String(left.no) === String(right.no));
};

class IssueAssignmentDialog extends Component {
   constructor(props) {
      super(props);
      const current = getAssignmentSelection(props.issue);
      this.state = { query: '', selection: current, current };
   }

   componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
         const current = getAssignmentSelection(this.props.issue);
         this.setState({ query: '', selection: current, current });
      }
   }

   _staffName = (staffMember) => {
      return (staffMember && staffMember.user && staffMember.user.name) || staffMember.name || `Staff #${staffMember.noUser}`;
   };

   _filteredStaff = () => {
      const query = this.state.query.trim().toLowerCase();
      return _.filter(this.props.staff || [], (item) => !query || this._staffName(item).toLowerCase().includes(query));
   };

   _filteredTeams = () => {
      const query = this.state.query.trim().toLowerCase();
      return _.filter(this.props.teams || [], (item) => !query || String(item.name || '').toLowerCase().includes(query));
   };

   render() {
      const { open, issue, saving, error, onClose, onSave, onUnassign } = this.props;
      const assigned = Boolean(this.state.current);
      const dirty = !sameSelection(this.state.selection, this.state.current);

      return (
         <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth='sm'>
            <DialogTitle>{assigned ? 'Reassign issue' : 'Assign issue'}</DialogTitle>
            <DialogContent>
               <div className='issue-assignment-current'>Current assignment: <strong>{this.props.currentCaption}</strong></div>
               <TextField
                  fullWidth
                  margin='normal'
                  label='Search staff or teams'
                  value={this.state.query}
                  onChange={(event) => this.setState({ query: event.target.value })}
                  disabled={saving}
               />
               {error && <div className='issue-assignment-error'>{error}</div>}
               <div className='issue-assignment-section'>Staff</div>
               <List dense>
                  {this._filteredStaff().map((item) => {
                     const no = item.noUser;
                     const selected = sameSelection(this.state.selection, { type: 'staff', no });
                     return (
                        <ListItem button key={`staff-${no}`} selected={selected} disabled={saving} onClick={() => this.setState({ selection: { type: 'staff', no } })}>
                           <ListItemText primary={this._staffName(item)} />
                        </ListItem>
                     );
                  })}
               </List>
               <div className='issue-assignment-section'>Teams</div>
               <List dense>
                  {this._filteredTeams().map((item) => {
                     const selected = sameSelection(this.state.selection, { type: 'team', no: item.no });
                     return (
                        <ListItem button key={`team-${item.no}`} selected={selected} disabled={saving} onClick={() => this.setState({ selection: { type: 'team', no: item.no } })}>
                           <ListItemText primary={item.name || `Team #${item.no}`} />
                        </ListItem>
                     );
                  })}
               </List>
            </DialogContent>
            <DialogActions>
               {assigned && <Button color='secondary' disabled={saving} onClick={() => onUnassign(issue)}>Unassign issue</Button>}
               <Button disabled={saving} onClick={onClose}>Cancel</Button>
               <Button color='primary' variant='contained' disabled={saving || !dirty || !this.state.selection} onClick={() => onSave(this.state.selection)}>
                  {saving ? 'Saving…' : 'Save'}
               </Button>
            </DialogActions>
         </Dialog>
      );
   }
}

IssueAssignmentDialog.propTypes = {
   open: PropTypes.bool.isRequired,
   issue: PropTypes.object,
   staff: PropTypes.array,
   teams: PropTypes.array,
   currentCaption: PropTypes.string,
   saving: PropTypes.bool,
   error: PropTypes.string,
   onClose: PropTypes.func.isRequired,
   onSave: PropTypes.func.isRequired,
   onUnassign: PropTypes.func.isRequired
};

export default IssueAssignmentDialog;
